import { ViewModel,View, ObservableArray } from "binder"
import  { ProductImageManipulationView } from "./productImageManipulation-view"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";
import { FileChooser, stringIsNullOrEmpty } from "src/common/utilities";
import { Converters } from "src/converters";

export class ProductImageManipulationViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.files = ObservableArray.create<singleFile>();
    }
    GetDefaultView(): View <ViewModel> {
        return new ProductImageManipulationView();
    }
    public getTypeId(): string {
        return "VM-A2116640-F230-4096-98DC-E8B4BB2D6D46"
    }

    closePopup(result?: any) {
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set productId(v: string) { this._productId = v; } public get productId(): string { return this._productId;} private _productId: string;
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId;} private _measuredProductId: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set isWrecked(v: boolean) { this._isWrecked = v; } public get isWrecked(): boolean { return this._isWrecked;} private _isWrecked: boolean;
    public set hasPicture(v: boolean) { this._hasPicture = v; } public get hasPicture(): boolean { return this._hasPicture;} private _hasPicture: boolean;
    public set locations(v: string) { this._locations = v; } public get locations(): string { return this._locations;} private _locations: string;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance;} private _balance: number;
    public set accessibleBalance(v: number) { this._accessibleBalance = v; } public get accessibleBalance(): number { return this._accessibleBalance;} private _accessibleBalance: number;
    public set files(v: ObservableArray<singleFile>) { this._files = v; } public get files(): ObservableArray<singleFile> { return this._files;} private _files: ObservableArray<singleFile>;
    public set capturedPicture(v: string) { 
        this._capturedPicture = v; 
        if(stringIsNullOrEmpty(v)==false){
            let newFile = new singleFile(this);
            
            newFile.content = v;
            newFile.name = '1.png';
            newFile.isNew = true;
            newFile.path = new Converters().b64ToSrcConverter(v);
            this.files.push(newFile);
        }
    } public get capturedPicture(): string { return this._capturedPicture;} private _capturedPicture: string;
    

    async loadById(measuredProductId:string){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ProductImagesServices/GetSingleProductImages',{
                MeasuredProductId : measuredProductId
            });
            if(result.IsSuccessful==false){
                this.messageBoxConfirmWarning('خطا در بارکذاری داده ها. لطفا دوباره تلاش کنید.','خطا در انجام عملیات');
                this.closePopup('no');
            }
            this.productId = result.ProductId;
            this.measuredProductId = result.MeasuredProductId;
            this.name = result.Name;
            this.code = result.Code;
            this.productCarModel = result.ProductCarModel;
            this.isWrecked = result.IsWrecked;
            this.locations = result.Location;
            this.balance = result.Balance;
            this.accessibleBalance = result.AccessibleBalance;
            this.hasPicture = result.HasPicture;
            this.files.update(...result.Files.map(y=>{
                let f = new singleFile(this);
                f.id = y.Id;
                f.name = y.Name;
                f.path = `/media/${y.Path}`;
                f.isNew = false;
                return f;
            }))
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }   
    
    removeFile(file:singleFile){
        this.files.remove(file);
    }

    async save(){
        try {
            this.isLoading = true;
            let result =await ServerConnection.callServer('/Complex/ProductImagesServices/UpdateSingleProductImages',{
                ProductId : this.productId,
                Images : this.files.map(x=>{
                    return {
                        Id: x.id,
                        Name : x.name,
                        IsNew : x.isNew,
                        Content : x.isNew ? x.content : ""
                    }
                })
            });
            if(result.IsSuccessful){
                this.messageBoxConfirmSuccess("عملیات با موفقیت انحام شد.","عملیات موفق")
                this.closePopup('yes');
            }else{
                this.messageBoxConfirmWarning("عملیات نا موفق","عملیات نا موفق");
            }
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning("عملیات نا موفق","عملیات نا موفق");
        } finally {
            this.isLoading = false;
        }
    }
    back(){
        this.closePopup('no');
    }

    async addFile(){
        let choosedFile =await new FileChooser().chooseFile();
        if(choosedFile.isChoosed){
            let newFile = new singleFile(this);
            
            newFile.content = choosedFile.fileContent;
            newFile.name = choosedFile.filename;
            newFile.isNew = true;
            newFile.path = new Converters().b64ToSrcConverter(choosedFile.fileContent);
            this.files.push(newFile);
        }
    }
}
export class singleFile extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ProductImageManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        this.isNew = true;
    }

    private _typedParent:ProductImageManipulationViewModel;

    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set path(v: string) { this._path = v; } public get path(): string { return this._path;} private _path: string;
    public set isNew(v: boolean) { this._isNew = v; } public get isNew(): boolean { return this._isNew;} private _isNew: boolean;
    public set content(v: string) { this._content = v; } public get content(): string { return this._content;} private _content: string;
    
    remove(){
        this._typedParent.removeFile(this);
    }

    open(){
        window.open(this.path,'_blank');
    }
}

